"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateJobSummary = void 0;
const core = __importStar(require("@actions/core"));
const github = __importStar(require("@actions/github"));
const summary_1 = require("@actions/core/lib/summary");
const request_error_1 = require("@octokit/request-error");
const params = __importStar(require("./input-params"));
const cache_reporting_1 = require("./cache-reporting");
function generateJobSummary(buildResults, cacheListener) {
    return __awaiter(this, void 0, void 0, function* () {
        const summaryTable = renderSummaryTable(buildResults);
        const cachingReport = (0, cache_reporting_1.generateCachingReport)(cacheListener);
        if (shouldGenerateJobSummary(buildResults)) {
            core.info('Generating Job Summary');
            core.summary.addRaw(summaryTable);
            core.summary.addRaw(cachingReport);
            yield core.summary.write();
        }
        else {
            core.info('============================');
            core.info(summaryTable);
            core.info('============================');
            core.info(cachingReport);
            core.info('============================');
        }
        if (shouldAddPRComment(buildResults)) {
            yield addPRComment(summaryTable);
        }
    });
}
exports.generateJobSummary = generateJobSummary;
function addPRComment(jobSummary) {
    return __awaiter(this, void 0, void 0, function* () {
        const context = github.context;
        if (context.payload.pull_request == null) {
            core.info('No pull_request trigger: not adding PR comment');
            return;
        }
        const pull_request_number = context.payload.pull_request.number;
        core.info(`Adding Job Summary as comment to PR #${pull_request_number}.`);
        const prComment = `<h3>Job Summary for gradle-build-action</h3>
<h5>${github.context.workflow} :: <em>${github.context.job}</em></h5>

${jobSummary}`;
        const github_token = params.getGithubToken();
        const octokit = github.getOctokit(github_token);
        try {
            yield octokit.rest.issues.createComment(Object.assign(Object.assign({}, context.repo), { issue_number: pull_request_number, body: prComment }));
        }
        catch (error) {
            if (error instanceof request_error_1.RequestError) {
                core.warning(buildWarningMessage(error));
            }
            else {
                throw error;
            }
        }
    });
}
function buildWarningMessage(error) {
    const mainWarning = `Failed to generate PR comment.\n${String(error)}`;
    if (error.message === 'Resource not accessible by integration') {
        return `${mainWarning}
Please ensure that the 'pull-requests: write' permission is available for the workflow job.
Note that this permission is never available for a workflow triggered from a repository fork.
        `;
    }
    return mainWarning;
}
function renderSummaryTable(results) {
    if (results.length === 0) {
        return 'No Gradle build results detected.';
    }
    return `
<table>
    <tr>
        <th>Gradle Root Project</th>
        <th>Requested Tasks</th>
        <th>Gradle Version</th>
        <th>Build Outcome</th>
        <th>Build Scan®</th>
    </tr>${results.map(result => renderBuildResultRow(result)).join('')}
</table>
    `;
}
function renderBuildResultRow(result) {
    return `
    <tr>
        <td>${result.rootProjectName}</td>
        <td>${result.requestedTasks}</td>
        <td align='center'>${result.gradleVersion}</td>
        <td align='center'>${renderOutcome(result)}</td>
        <td>${renderBuildScan(result)}</td>
    </tr>`;
}
function renderOutcome(result) {
    return result.buildFailed ? ':x:' : ':white_check_mark:';
}
function renderBuildScan(result) {
    if (result.buildScanFailed) {
        return renderBuildScanBadge('PUBLISH_FAILED', 'orange', 'https://docs.gradle.com/enterprise/gradle-plugin/#troubleshooting');
    }
    if (result.buildScanUri) {
        return renderBuildScanBadge('PUBLISHED', '06A0CE', result.buildScanUri);
    }
    return renderBuildScanBadge('NOT_PUBLISHED', 'lightgrey', 'https://scans.gradle.com');
}
function renderBuildScanBadge(outcomeText, outcomeColor, targetUrl) {
    const badgeUrl = `https://img.shields.io/badge/Build%20Scan%C2%AE-${outcomeText}-${outcomeColor}?logo=Gradle`;
    const badgeHtml = `<img src="${badgeUrl}" alt="Build Scan ${outcomeText}" />`;
    return `<a href="${targetUrl}" rel="nofollow">${badgeHtml}</a>`;
}
function shouldGenerateJobSummary(buildResults) {
    if (!process.env[summary_1.SUMMARY_ENV_VAR]) {
        return false;
    }
    if (!params.isJobSummaryEnabled()) {
        return false;
    }
    return shouldAddJobSummary(params.getJobSummaryOption(), buildResults);
}
function shouldAddPRComment(buildResults) {
    return shouldAddJobSummary(params.getPRCommentOption(), buildResults);
}
function shouldAddJobSummary(option, buildResults) {
    switch (option) {
        case params.JobSummaryOption.Always:
            return true;
        case params.JobSummaryOption.Never:
            return false;
        case params.JobSummaryOption.OnFailure:
            core.info(`Got these build results: ${JSON.stringify(buildResults)}`);
            return buildResults.some(result => result.buildFailed);
    }
}
